<template>
  <!-- is-justify-content-center -->
  <div
    class="is-flex is-align-items-center"
    style="height: 100%; gap: 0.25rem"
    @click.stop
  >
    <!-- Botón de enviar correo -->
    <button
      class="button is-small"
      title="Enviar correo"
      :disabled="
        ['finished', 'calculated'].includes(this.params.data.status) ||
          !this.params.data.email.length
      "
      v-on:click="onSendEmail"
    >
      <span class="icon is-small">
        <i class="mdi mdi-email"></i>
      </span>
    </button>

    <!-- Botón de mostrar resultados temporalmente -->
    <button
      class="button is-small"
      title="Mostrar resultados"
      :disabled="!['finished', 'calculated'].includes(this.params.data.status)"
      v-on:click="onResults"
    >
      <span class="icon is-small">
        <i class="mdi mdi-database-eye-outline"></i>
      </span>
    </button>

    <!-- Botón de menú de acciones -->
    <b-dropdown
      class="dropdown-actions-collaborator"
      position="is-bottom-left"
      append-to-body
      :mobile-modal="false"
      trap-focus
    >
      <button
        class="button is-small"
        slot="trigger"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        title="Más acciones"
      >
        <span class="icon is-small">
          <i class="material-icons">more_horiz</i>
        </span>
      </button>

      <b-dropdown-item v-on:click="onEdit">
        <span class="icon is-small"><i class="mdi mdi-pencil"></i></span>
        <span>Editar</span>
      </b-dropdown-item>

      <b-dropdown-item v-on:click="onDelete">
        <span class="icon is-small"><i class="mdi mdi-delete"></i></span>
        <span>Eliminar</span>
      </b-dropdown-item>

      <b-dropdown-item v-on:click="onLinkSurvey">
        <span class="icon is-small"><i class="mdi mdi-link-variant"></i></span>
        <span>Link encuesta</span>
      </b-dropdown-item>

      <b-dropdown-item
        v-if="this.params.data.email.length"
        v-on:click="onHistoric"
      >
        <span class="icon is-small"><i class="mdi mdi-history"></i></span>
        <span>Histórico de correo</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "ActionsEmailProcess",
  methods: {
    onSendEmail() {
      const componentParent = this.params.context.componentParent;
      componentParent.handleSendEmail(this.params.data._id);
    },
    onEdit() {
      const componentParent = this.params.context.componentParent;
      componentParent.handleShowEdit(this.params.data);
    },
    onDelete() {
      const componentParent = this.params.context.componentParent;
      componentParent.handleDeleteCollaborator(this.params.data._id);
    },
    onHistoric() {
      const componentParent = this.params.context.componentParent;
      componentParent.handleShowEmailHistory(this.params.data);
    },
    onLinkSurvey() {
      const link = `${window.location.origin}/cultura/survey/${this.params.data._id}`;
      const input = document.createElement("input");
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);

      this.$buefy.toast.open({
        message: "Copiado al portapapeles!",
        type: "is-info",
      });
    },
    // Temporal
    onResults() {
      const componentParent = this.params.context.componentParent;
      componentParent.handleResults(this.params.data);
    },
  },
};
</script>

<style>
.dropdown-actions-collaborator .dropdown-trigger {
  display: flex;
}
.dropdown-actions-collaborator .dropdown-trigger .button:focus {
  border-color: unset !important;
  box-shadow: unset !important;
}
</style>

<style scoped>
.dropdown-actions-collaborator .button.is-small {
  border: none;
  background: transparent;
  padding: 0.25rem;
  width: 25px;
  height: 25px;
}

.dropdown-actions-collaborator .button.is-small:hover {
  background: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/components/Collaborator/ActionsCollaborator.vue